/**
 * 元素全屏
 * @param element
 * @param method
 * @return
 */
export const runPrefixMethod = (element: any, method: any) => {
  let usablePrefixMethod: any;

  ["webkit", "moz", "ms", "o", ""].forEach(function (prefix) {
    if (usablePrefixMethod) return;
    if (prefix === "") {
      method = method.slice(0, 1).toLowerCase() + method.slice(1);
    }
    const typePrefixMethod = typeof element[prefix + method];

    if (typePrefixMethod + "" !== "undefined") {
      if (typePrefixMethod === "function") {
        usablePrefixMethod = element[prefix + method]();
      } else {
        usablePrefixMethod = element[prefix + method];
      }
    }
  });

  return usablePrefixMethod;
};
